import { Text } from '@radix-ui/themes';
import { t } from 'i18next';
import { IInputHint } from 'interfaces/forms/_base';
import { ITextBase } from 'interfaces/forms/text';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useMemo } from 'react';

export const HINT_DELIMITER = ' · ';

interface IProps extends IInputHint, ITextBase {}

export const CommonTextHint = (props: IProps) => {
  const blurbs = useMemo(
    () =>
      [
        props.hint_md,
        props.maxLength !== undefined && props.maxLength > 0
          ? t('common.x-of-y-character-limit', {
              x: props.value?.length ?? 0,
              y: props.maxLength,
            })
          : undefined,
      ]
        .filter((s) => s)
        .join(HINT_DELIMITER),
    [props.hint_md, props.maxLength, props.value]
  );

  if (blurbs.length === 0) {
    return null;
  }

  return (
    <Text size={RADIX.TEXT.SIZE.HINT} color={RADIX.COLOR.NEUTRAL}>
      {blurbs}
    </Text>
  );
};
